import "./App.css";
import Navbar from "./NavBar";
import Main from "./Main";
function App() {
  return (
    <div className="bg-white w-[100vw] h-full overflow-x-hidden">
      <Navbar>
      </Navbar>
  
      <Main></Main>
      
   </div>
  );
}

export default App;
